(function () {
  'use strict';

  var FEEDS = 'https://integrations.etrusted.com/';
  var MINDESTHOEHE_SHOP = 30;

  var kanalJeWidget = {};   /* Widget-Kennung → Promise<Kanal-Id> */
  var anzahlJeGtin = {};    /* GTIN → Promise<Anzahl Bewertungen> */

  function json(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : {};
    });
  }

  function kanal(widgetId) {
    if (!kanalJeWidget[widgetId]) {
      kanalJeWidget[widgetId] = json(FEEDS + 'manifests/v1/' + widgetId + '.json')
        .then(function (m) { return (m.reference && m.reference.id) || ''; });
    }
    return kanalJeWidget[widgetId];
  }

  function anzahlBewertungen(widgetId, gtin) {
    if (!anzahlJeGtin[gtin]) {
      anzahlJeGtin[gtin] = kanal(widgetId).then(function (ch) {
        if (!ch) return 0;
        return json(FEEDS + 'feeds/mappings/gtin/v1/channels/' + ch + '/' + encodeURIComponent(gtin) + '/mapping.json')
          .then(function (map) {
            var skus = (map.products || []).map(function (p) { return p.sku; }).filter(Boolean);
            return Promise.all(skus.map(function (sku) {
              /* Die SKU steht hexkodiert im Pfad — so ruft es auch das Widget auf. */
              var hex = Array.prototype.map.call(unescape(encodeURIComponent(sku)), function (c) {
                return ('0' + c.charCodeAt(0).toString(16)).slice(-2);
              }).join('');
              return json(FEEDS + 'feeds/grades/v1/channels/' + ch + '/products/sku/' + hex + '/feed.json')
                .then(function (g) { return (g.grades && g.grades.overall && g.grades.overall.count) || 0; });
            })).then(function (zahlen) {
              return zahlen.reduce(function (a, b) { return a + b; }, 0);
            });
          });
      }).catch(function () { return 0; });
    }
    return anzahlJeGtin[gtin];
  }

  function pruefeProdukt(block, widget) {
    if (block.dataset.tsGeprueft) return;
    block.dataset.tsGeprueft = '1';
    anzahlBewertungen(widget.getAttribute('data-etrusted-widget-id'), widget.getAttribute('data-gtin'))
      .then(function (n) { block.hidden = !(n > 0); });
  }

  function pruefeShop(block, widget) {
    var war = block.hidden;
    block.hidden = false;                       /* messen geht nur sichtbar */
    var hoehe = widget.getBoundingClientRect().height;
    block.hidden = hoehe < MINDESTHOEHE_SHOP;
    if (block.hidden && !war) block.hidden = true;
  }

  function pruefen() {
    document.querySelectorAll('[data-ts-block]').forEach(function (block) {
      var widget = block.matches('etrusted-widget') ? block : block.querySelector('etrusted-widget');
      if (!widget) { block.hidden = true; return; }
      if (widget.hasAttribute('data-gtin')) pruefeProdukt(block, widget);
      else pruefeShop(block, widget);
    });
  }

  /* Shop-Widgets laden asynchron und rendern nachträglich; zehn Sekunden
     Beobachtung reichen dafür und laufen dann aus. Produkt-Blöcke sind nach der
     ersten Prüfung markiert und werden nicht erneut angefragt. */
  var versuche = 0;
  var takt = setInterval(function () {
    pruefen();
    if (++versuche >= 20) clearInterval(takt);
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruefen);
  } else {
    pruefen();
  }
  document.addEventListener('shopify:section:load', pruefen);
})();
